/**
 * Poll-related type definitions
 */

export interface Poll {
  id: string;
  message_id: string;
  chat_id: string;
  question: string;
  is_anonymous: boolean;
  allows_multiple_answers: boolean;
  closes_at: string | null;
  is_closed: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface PollOption {
  id: string;
  poll_id: string;
  option_text: string;
  option_order: number;
  created_at: string;
}

export interface PollVote {
  id: string;
  poll_id: string;
  option_id: string;
  user_id: string;
  created_at: string;
}

export interface PollOptionWithVotes extends PollOption {
  votes: PollVote[];
  vote_count: number;
  voted_by_current_user: boolean;
}

export interface PollWithDetails extends Poll {
  options: PollOptionWithVotes[];
  total_votes: number;
  has_voted: boolean;
  creator?: {
    id: string;
    full_name: string | null;
    nickname: string | null;
    avatar_url: string | null;
  };
}

export interface CreatePollInput {
  chat_id: string;
  question: string;
  options: string[];
  is_anonymous?: boolean;
  allows_multiple_answers?: boolean;
  closes_at?: Date | null;
}

